import styled, { keyframes } from 'styled-components';

import { useLocation } from 'react-router-dom';
import { routes } from '../../../Routes';

import S from '../variables';

import { Sidebar } from '../../Sidebar';

const comeIn = keyframes`
0% {
    transform: translateX(-10%);
    filter: brightness(10) blur(6px) drop-shadow(0 0 64px rgba(212, 174, 139, 0.6));
);
}
100% {
  transform: translateX(0);
    opacity: 1;
    filter: brightness(1);
}
`;

export const StyledFlexContainer = styled.div`
  display: flex;
  justify-content: ${props => props.justify || 'center'};
  align-items: ${props => props.align || 'center'};
  flex-direction: ${props => props.direct || 'row'};
  flex-wrap: ${props => props.wrap || 'nowrap'};
  & > * {
    &:not(:last-child) {
      margin-right: ${props => props.mr || '0px'};
    }
  }
  height: ${props => props.ht || 'auto'};
  ${props => props.minht && `min-height: ${props.minht};`}
  width: ${props => props.wd || 'auto'};
  background: ${props => props.bg || 'transparent'};
  color: ${props => props.clr};
  padding: ${props => props.pd || '0px'};
`;

export const Container = styled.div`
  max-width: 1320px;
  padding: 0 20px;
  margin: 0 auto;
  @media screen and (min-width: ${S.desktop}) {
    padding-top: 0;
  }
  animation: 500ms ${comeIn} ease-out;
`;

const StyledMainContainer = styled(Container)`
  padding: 120px 0 0;
  background-color: ${S.mainBg};
  max-width: 100%;
  min-height: 100vh;
  @media screen and (min-width: ${S.desktop}) {
    padding-top: 0;
    & .console {
      padding-left: 237px;
      max-width: 1320px;
      margin: 0 auto;
    }
  }
  animation: none;
`;

const SidebarContainer = styled(Container)`
  animation: none;
  @media screen and (min-width: ${S.desktop}) {
    position: absolute;
    z-index: 99;
    width: 100%;
    top: 160px;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    & ul {
      pointer-events: auto;
    }
  }
`;

export const MainContainer = ({ auth, children }) => {
  const location = useLocation();

  const locArr = location.pathname.split('/');

  const inConsole = routes.find(({ path }) => {
    const pathArr = path.split('/');
    return (
      pathArr.filter((el, i) =>
        el[0] === ':' ? !!locArr[i] : el === locArr[i],
      ).length === pathArr.length
    );
  })?.sidebarLink;

  return (
    <StyledMainContainer as="main">
      {auth && inConsole && (
        <SidebarContainer>
          <Sidebar />
        </SidebarContainer>
      )}
      <div className={inConsole ? 'console' : ''}>{children}</div>
    </StyledMainContainer>
  );
};
